import { useState } from "react";
import { AiFillCaretDown, AiOutlinePlusCircle } from "react-icons/ai";
import { IoSearchOutline } from "react-icons/io5";
import { MdOutlineNotifications } from "react-icons/md";
import { useStores } from "../../../store";
import Notification from "../../dashboard/Notification";
import { useObserver } from "mobx-react";
import { HiOutlineAdjustmentsHorizontal } from "react-icons/hi2";
import { FilterJobs } from "../../dashboard/filterJobs";
import { IoMdRefresh } from "react-icons/io";

const ResponsiveHeader = ({
  title,
  showSearch = true,
  showButton = true,
  showDropdown = true,
  showNotification = true,
  buttonLable = "Create New",
  searchPlaceHolder = "Search",
  onClickButton,
  handleInputChange,
  selectorOptions,
  selectorAction,
  onKeyPress,
  name,
  addfilter,
  showrefresh = false,
  refreshAction,
  isDropdownOpen,
  setIsDropdownOpen,
  onblur,
}) => {
  const [active, setActive] = useState(0);
  const { PopupStore } = useStores();
  const [showFilter, setShowFilter] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [selectedOption, setSelectedOption] = useState(
    selectorOptions ? selectorOptions[0]?.name : "Select an option",
  );

  const handleSearch = () => {
    if (onKeyPress) {
      onKeyPress({ key: "Enter", target: { value: searchValue } });
    }
  };

  const _handleInputChange = (e) => {
    setSearchValue(e.target.value);
    if (handleInputChange) {
      handleInputChange(e);
    }
  };

  return useObserver(() => (
    <div className="w-full flex flex-col pt-4 pb-2  md:-ml-4 ">
      {PopupStore.notification && (
        <Notification
          popUpInitialValue={PopupStore.notification}
          handlePopup={() => PopupStore.setNotification(false)}
        />
      )}
      <div className="flex items-center  gap-5 justify-between">
        {/* Left Section */}
        <div className="flex items-center  gap-9">
          <h2 className="text-orange-500  font-semibold md:text-[24px] lg:text-2xl text-lg md:ml-4 ml-1 ">
            {title}
          </h2>
        </div>

        {addfilter && (
          <div
            onClick={() => setShowFilter(true)}
            className="flex bg-[#f1f1f1] items-center ml-auto text-2xl justify-center w-10 rounded-lg px-3 py-1.5 md:hidden lg:hidden cursor-pointer"
          >
            <HiOutlineAdjustmentsHorizontal />
          </div>
        )}
        {showFilter && (
          <FilterJobs
            show={showFilter}
            onClose={() => setShowFilter(false)}
            onCancle={() => setShowFilter(false)}
          />
        )}

        {/* Right Section */}
        <div className="flex md:-mr-4 lg:-mr-4  gap-10">
          {showNotification && (
            <div
              onClick={() => PopupStore.setNotification(true)}
              className="flex bg-[#f1f1f1] items-center justify-center w-fit rounded-lg md:px-3 md:py-3 px-2 py-2 md:rounded-xl lg:rounded-xl cursor-pointer"
            >
              <MdOutlineNotifications className="text-xl md:text-2xl text-black" />
            </div>
          )}

          {showSearch && (
            <div className="items-center justify-between pr-4  rounded-lg border-[#FF6B00] border w-full md:w-[300px] hidden md:flex lg:flex">
              <input
                onKeyPress={onKeyPress}
                type="text"
                placeholder={searchPlaceHolder}
                className="w-full py-3 pl-4 pr-8 text-sm outline-none text-gray-600 rounded-lg"
                onChange={_handleInputChange}
                onBlur={onblur}
                value={searchValue}
              />
              <IoSearchOutline
                onClick={handleSearch}
                className="text-[#FF6B00] text-xl font-bold cursor-pointer"
              />
            </div>
          )}

          {showDropdown && (
            <div className="flex items-center relative">
              {/* Custom Dropdown Button */}
              <div
                className="focus:outline-none flex flex-row appearance-none bg-primary text-white text-sm rounded-lg p-2 px-4 py-3 pr-10 items-center cursor-pointer"
                onClick={() => setIsDropdownOpen(!isDropdownOpen)}
              >
                <span className="w-full text-center">{selectedOption}</span>
                <AiFillCaretDown className="absolute right-4 text-white pointer-events-none" />
              </div>

              {/* Custom Dropdown Menu */}
              {isDropdownOpen && (
                <div className="absolute top-full mt-1 w-full bg-white text-black rounded-lg shadow-md z-10">
                  {selectorOptions.map((button) => (
                    <div
                      key={button.id}
                      className="p-2 py-3 hover:bg-primary hover:bg-opacity-30 cursor-pointer rounded-lg text-center"
                      onClick={() => {
                        setSelectedOption(button.name);
                        setIsDropdownOpen(false);
                        selectorAction({ target: { value: button.id } });
                      }}
                    >
                      {button.name}
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}

          {showrefresh && (
            <div
              onClick={refreshAction}
              className="flex bg-primary items-center justify-center w-fit rounded-lg px-3 py-3 cursor-pointer"
            >
              <IoMdRefresh className="text-xl text-white" />
            </div>
          )}

          {showButton && (
            <button
              className="flex items-center gap-2 border  md:-mr-3 bg-primary  text-white px-4 rounded-xl"
              onClick={onClickButton}
            >
              <AiOutlinePlusCircle />
              <span className="hidden md:inline">{buttonLable}</span>
            </button>
          )}
        </div>
      </div>

      {showSearch && (
        <div className="flex items-center justify-between pr-2  rounded-lg border-orange-400 border w-full mt-4 md:hidden lg:hidden">
          <input
            onKeyPress={onKeyPress}
            type="text"
            placeholder={searchPlaceHolder}
            className="w-full py-2 pl-4 pr-10 text-sm outline-none text-gray-600 rounded-lg"
            onChange={_handleInputChange}
            onBlur={onblur}
            value={searchValue}
          />
          <IoSearchOutline
            onClick={handleSearch}
            className="text-primary cursor-pointer"
          />
        </div>
      )}
    </div>
  ));
};

export default ResponsiveHeader;
